export default "__VITE_ASSET__BcudS0I7__"